import styled from 'styled-components';
import Icon from '@adecco/base-app/src/components/atoms/Icon/Icon';
import Paragraph from '@adecco/base-app/src/components/atoms/Paragraph/Paragraph';
import Container from '@adecco/base-app/src/components/atoms/Container/Container';
import { ListItem, OrderedList } from '@adecco/base-app/src/components/molecules/LinkList/LinkList';

interface Props {
  items: string[];
}

const StyledContainer = styled(Container)`
  text-align: center;
`;

const StyledIcon = styled(Icon)`
  margin-right: ${(props) => props.theme.margins.linkListIcon};
`;

const StyledParagraph = styled(Paragraph)`
  font-size: ${(props) => props.theme.fontSizes.linkList};
  font-weight: ${(props) => props.theme.fontWeights.listParagraph};
`;

const ListComponent: React.FC<Props> = ({ items }) => {
  return (
    <StyledContainer>
      <OrderedList>
        {items.map((data, index) => (
          <ListItem key={index}>
            <div>
              <StyledIcon name="checkmark-red" width={30} height={30} />
            </div>
            <StyledParagraph>{data}</StyledParagraph>
          </ListItem>
        ))}
      </OrderedList>
    </StyledContainer>
  );
};

export default ListComponent;
